import * as React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { useLocation } from "react-router-dom";
import useAuth from "./hooks/useAuth";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setTranslations } from "./redux/actions";
import { setLanguage } from "./redux/actions";
import { getPreferedLanguage } from "./utils/localStorage";

//Navigation
import Default from "./components/navigation/Default";
import Footer from "./components/navigation/Footer";

//Pages
import NotFound from "./pages/NotFoundPage";
import LoginPage from "./pages/login/LoginPage";

import SearchPage from "./pages/home/private/admin/searchPage";


function RequireAuth({ children }) {
  const { isAuthed } = useAuth();
  const location = useLocation();
  return isAuthed() === true ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ path: location.pathname }} />
  );
}

function RequireNoAuth({ children }) {
  const { isAuthed } = useAuth();
  const location = useLocation();
  return isAuthed() === false ? (
    children
  ) : (
    <Navigate to="/adminview" replace state={{ path: location.pathname }} />
  );
}

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Load translations file
    const fetchTranslations = async () => {
      try {
        dispatch(setLanguage(getPreferedLanguage()));
      } catch {
        console.log("No language set");
      }

      try {
        const response = await fetch("/lang/translation.json");
        const data = await response.json();
        dispatch(setTranslations(data));
      } catch (error) {
        console.error("Error fetching translations:", error);
      }
    };

    fetchTranslations();
  }, [dispatch]);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Default />
      <div className="flex-grow-1">
        <Routes>
          <Route
            path="/login"
            element={
              <RequireNoAuth>
                <LoginPage />
              </RequireNoAuth>
            }
          />
          <Route
            path="/adminview"
            element={
              <RequireAuth>
                <SearchPage />
              </RequireAuth>
            }
          />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Navigate to="/adminview" replace />
              </RequireAuth>
            }
          />
          <Route path="404" element={<NotFound />} />
          <Route
            path="*"
            element={
              <RequireAuth>
                <NotFound />
              </RequireAuth>
            }
          />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}
